import React from 'react';
type TrustStripProps = {
  items: string[];
  className?: string;
};
export function TrustStrip({
  items,
  className = ''
}: TrustStripProps) {
  return <ul className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-muted sm:text-[11px] ${className}`} data-id="element-232" data-mp="2o5vvggpchvc4">
      {items.map(label => <li key={label} className="flex items-center gap-2 whitespace-nowrap" data-id="element-233" data-mp="2acebwvwnsim3">
          <span className="h-1 w-1 shrink-0 rounded-full bg-pumpkin" aria-hidden="true" data-id="element-234" data-mp="2aabbdhxvr734" />
          {label}
        </li>)}
    </ul>;
}